import { Modal, message } from 'antd';
import { useAppDispatch } from "common/hook";
import { deleteTest } from "features/model/service/test/delete-test/deleteTest";
import { useNavigate } from "react-router-dom";

const useDeleteTestHandler = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const onClickDeleteHandler = async (testId: string | undefined) => {
        const modal = Modal.info({
            title: (
                <div className='h3 popup-title popup-title-modal'>
                    Удаление теста
                </div>
            ),
            content: (
                <div className='popup-text'>
                    Вы уверены, что хотите удалить этот тест?
                </div>
            ),
            okText: 'Да',
            cancelText: 'Нет',
            onOk: async () => {
                try {
                    await dispatch(deleteTest(testId)).unwrap();
                    modal.destroy();
                    navigate(`/test/`);
                } catch (error) {
                    message.error('Не удалось удалить тест.');
                    modal.destroy();
                }
            },
            onCancel: () => {
                modal.destroy();
            },
            footer: (
                <div style={{ display: 'flex', gap: '20px', width: '100%' }}>
                    <button
                        style={{ width: '100%' }}
                        className="btn secondary"
                        onClick={() => {
                            modal.destroy();
                        }}
                    >
                        Отменить
                    </button>
                    <button
                        style={{ width: '100%' }}
                        className="btn order2-desktop"
                        onClick={async () => {
                            try {
                                await dispatch(deleteTest(testId)).unwrap();
                                modal.destroy();
                                navigate(`/test/`);
                            } catch (error) {
                                message.error('Не удалось удалить тест.');
                                modal.destroy();
                            }
                        }}
                    >
                        Удалить
                    </button>
                </div>
            ),
        });
    };

    return onClickDeleteHandler;
};

export default useDeleteTestHandler;
